export default __webpack_public_path__ + "static/media/iconos.b12ca16d.png";